export default __webpack_public_path__ + "static/media/docker.c5f325f0.png";